<template>
  <cart v-if="cashRegister.openedReport" />
</template>

<script>
import Vue from 'vue'
import Cart from '@/components/Checkout/Cart'
import FormsCashRegistersOpen from '@/components/forms/cash-registers/FormsCashRegistersOpen'
import { mapGetters } from 'vuex'

export default {
  metaInfo () {
    return { title: this.pageTitle }
  },

  components: {
    Cart,
    FormsCashRegistersOpen
  },

  data: () => ({
    pageTitle: Vue.i18n.translate('Cart')
  }),

  computed: {
    ...mapGetters(['cashRegister'])
  },

  watch: {
    cashRegister: {
      immediate: true,
      handler (cashRegister) {
        this.checkRedirect()
      }
    }
  },

  methods: {
    checkRedirect () {
      if (_.size(this.cashRegister) && !this.cashRegister.openedReport) {
        this.$router.push({ name: 'CashRegistersOpenClose' })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Cart.vue